import { render, staticRenderFns } from "./ringkasanMaklumatIsiRumah.vue?vue&type=template&id=93240dde"
import script from "./ringkasanMaklumatIsiRumah.vue?vue&type=script&lang=js"
export * from "./ringkasanMaklumatIsiRumah.vue?vue&type=script&lang=js"
import style0 from "./ringkasanMaklumatIsiRumah.vue?vue&type=style&index=0&id=93240dde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports